module.exports = __webpack_public_path__ + "87da19f4366ed83e131ea37bdc85d777.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gingerbread-house-empty.png
// module id = 308
// module chunks = 0